import React, { useState, useEffect, useRef, useMemo } from "react";
//assets
import arrowOff from "img/QuoteDropDownOff.svg";
import arrowOn from "img/QuoteDropDownOn.svg";
//components
import { Column, Row } from "components/Layout/Grid";
import Text from "components/Text";
//interfaces
import { OptionsDropdownProps } from "../QuoteStatusFilter/interface";
//styles
import "../QuoteStatusFilter/style.scss";

interface QuoteStatusFilterProps {
  selectedBionexoStatus: string[];
  selectedViveoStatus: string[];
  selectedOrderStatus?: string[];
  orderRadioSelected?: boolean;
  dashboardQuoteFilter?: any;
  setStatusBionexo: any;
  setStatusViveo: any;
  setOrderStatus?: any;
  setCurrentPage: (currentPage: number) => void;
  notReloadStatus?: boolean;
}

const QuoteStatusFilterNew: React.FC<QuoteStatusFilterProps> = (props) => {
  const {
    selectedBionexoStatus,
    selectedViveoStatus,
    selectedOrderStatus,
    orderRadioSelected,
    dashboardQuoteFilter,
    setStatusBionexo,
    setStatusViveo,
    setOrderStatus,
    setCurrentPage,
    notReloadStatus
  } = props;

  const [open, setOpen] = useState<boolean>(false);
  const [style, setStyle] = useState<string>("none");
  const [arrow, setArrow] = useState<string>(arrowOff);
  const [searchListBionexo, setSearchListBionexo] = useState<OptionsDropdownProps[]>([]);
  const [searchListViveo, setSearchListViveo] = useState<OptionsDropdownProps[]>([]);
  const [searchOrderOptions, setSearchOrderOptions] = useState<OptionsDropdownProps[]>([]);

  const dropdownMenu: any = useRef(null);

  useMemo(() => {
    if (dashboardQuoteFilter) {
      setSearchListBionexo(dashboardQuoteFilter.bionexoOptions || []);
      setSearchListViveo(dashboardQuoteFilter.viveoOptions || []);
      setSearchOrderOptions(dashboardQuoteFilter.orderOptions || []);
    }
  }, [dashboardQuoteFilter]);

  const handleOpenCloseDropDownMenu = () => {
    if (open === false) {
      setOpen(true);
      setStyle("block");
      setArrow(arrowOn);
    } else {
      setOpen(false);
      setStyle("none");
      setArrow(arrowOff);
    }
  };

  const closeOpenMenus = (e: any) => {
    if (dropdownMenu?.current && open && !dropdownMenu?.current.contains(e.target)) {
      handleOpenCloseDropDownMenu();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", closeOpenMenus);
  }, [open]);

  const handleBionexoStatus = (selectedDashboardQuoteFilterProps: any) => {
    let newCatSelection: string[] = selectedBionexoStatus;

    if (selectedDashboardQuoteFilterProps.target.checked) {
      newCatSelection.push(selectedDashboardQuoteFilterProps.target.value);
    } else {
      newCatSelection = newCatSelection.filter(
        (cat: string) => cat !== selectedDashboardQuoteFilterProps.target.value
      );
    }
    setStatusBionexo([...newCatSelection]);
    !notReloadStatus && setCurrentPage(0);
  };

  const handleViveoStatus = (selectedDashboardQuoteFilterProps: any) => {
    let newCatSelection: string[] = selectedViveoStatus;

    if (selectedDashboardQuoteFilterProps.target.checked) {
      newCatSelection.push(selectedDashboardQuoteFilterProps.target.value);
    } else {
      newCatSelection = newCatSelection.filter(
        (cat: string) => cat !== selectedDashboardQuoteFilterProps.target.value
      );
    }
    setStatusViveo([...newCatSelection]);
    !notReloadStatus && setCurrentPage(0);
  };

  const handleOrderStatus = (selectedDashboardOrderFilterProps: any) => {
    if (!setOrderStatus || !selectedOrderStatus) return;
    
    let newStatusSelection: string[] = selectedOrderStatus;

    if (selectedDashboardOrderFilterProps.target.checked) {
      newStatusSelection.push(selectedDashboardOrderFilterProps.target.value);
    } else {
      newStatusSelection = newStatusSelection.filter(
        (status: string) => status !== selectedDashboardOrderFilterProps.target.value
      );
    }
    setOrderStatus([...newStatusSelection]);
    !notReloadStatus && setCurrentPage(0);
  };

  const selectedCount = orderRadioSelected 
    ? (selectedOrderStatus?.length || 0)
    : (selectedBionexoStatus.length + selectedViveoStatus.length);

  return (
    <Row className="w-md-100">
      <Column className="w-md-100">
        <Row>
          <Text className="StatusFilterLabel" size={12}>
            Status
          </Text>
        </Row>
        <div ref={dropdownMenu}>
          <Row>
            <Column className="w-md-100">
              <div
                className="StatusFilterDropDown w-md-100"
                style={{ borderColor: open ? "#0E4C54" : "#BEBEBE" }}
                onClick={() => {
                  handleOpenCloseDropDownMenu();
                }}
              >
                <Text size={12}>Selecionados ({selectedCount})</Text>
                <img alt="arrow icon" src={arrow} />
              </div>
            </Column>
          </Row>
          <Row>
            <div className="StatusFilterOptionsArea" style={{ display: style }}>
              <div>
                {orderRadioSelected ? (
                  <>
                    <li className="StatusFilterStatusPlace">Status do pedido</li>
                    <ul>
                      {searchOrderOptions
                        .filter((value) => {
                          const statusLower = value.status?.toLowerCase().trim();
                          return statusLower === "confirmado" || statusLower === "cancelado";
                        })
                        .map((value) => {
                          return (
                            <li className="StatusFilterStatusRow" key={value.value}>
                              <label className="StatusFilterStatusItem">
                                <input
                                  type="checkbox"
                                  onChange={(event) => handleOrderStatus(event)}
                                  value={value.value}
                                  name={`opt-${value.status}`}
                                  className="StatusFilterCheckbox"
                                  checked={!!selectedOrderStatus?.find(element => element === value.value)}
                                />
                                <span className="StatusFilterCheckbox"></span>
                                <span className="StatusFilterStatusLabel">
                                  {value.status}
                                </span>
                              </label>
                            </li>
                          );
                        })}
                    </ul>
                  </>
                ) : (
                  <>
                    <li className="StatusFilterStatusPlace">Status Origem</li>
                    <ul>
                      {searchListBionexo.map((value) => {
                        return (
                          <li className="StatusFilterStatusRow" key={value.value}>
                            <label className="StatusFilterStatusItem">
                              <input
                                type="checkbox"
                                onChange={(event) => handleBionexoStatus(event)}
                                value={value.value}
                                name={`opt-${value.status}`}
                                className="StatusFilterCheckbox"
                                checked={!!selectedBionexoStatus.find(element => element === value.value)}
                              />
                              <span className="StatusFilterCheckbox"></span>
                              <span className="StatusFilterStatusLabel">
                                {value.status}
                              </span>
                            </label>
                          </li>
                        );
                      })}
                    </ul>
                    <li className="StatusFilterStatusPlace">Status Viveo</li>
                    <ul>
                      {searchListViveo.map((value) => {
                        return (
                          <li className="StatusFilterStatusRow" key={value.value}>
                            <label className="StatusFilterStatusItem">
                              <input
                                type="checkbox"
                                onChange={(event) => handleViveoStatus(event)}
                                value={value.value}
                                name={`opt-${value.status}`}
                                className="StatusFilterCheckbox"
                                checked={!!selectedViveoStatus.find(element => element === value.value)}
                              />
                              <span className="StatusFilterCheckbox"></span>
                              <span className="StatusFilterStatusLabel">
                                {value.status}
                              </span>
                            </label>
                          </li>
                        );
                      })}
                    </ul>
                  </>
                )}
              </div>
            </div>
          </Row>
        </div>
      </Column>
    </Row>
  );
};

export default QuoteStatusFilterNew;

